import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DateFormatService {
    private currentFormat = 'MM/dd/yyyy'; // Default format

    setDateFormat(format: string) {
        this.currentFormat = format;
    }

    getDateFormat(): string {
        return this.currentFormat;
    }
}
